import { defineStore } from 'pinia';
import { carAdvisoryGetters } from './getters';
import { carAdvisoryActions } from './actions';
import { ICarSelectStoreState } from '../../interfaces/ICarSelectStoreState';
import * as data from '../../data/sort-option.json';

// get the default sort
const defaultSort: any = data.sortOptions.find((sortOptionItem) => sortOptionItem?.default === true);

export const useCarSelectStore = defineStore('carSelectStore', {
  state: (): ICarSelectStoreState => ({
    selectedSortOrder: [defaultSort],
    selectedMakes: [],
    selectedModels: [],
    selectedBadges: [],
    selectedYear: {},
    selectedPrice: {},
    selectedTowingCapacities: [],
    selectedBodyTypes: [],
    selectedFuelTypes: [],
    selectedLifestyles: [],
    selectedEmissionsRatings: [],
    selectedDrivingRanges: [],
    selectedTransmissionTypes: [],
    selectedDriveTypes: [],
    selectedEngineTypes: [],
    selectedCylinders: [],
    selectedEngineCapacities: [],
    selectedFuelScores: [],
    selectedSafetyRatings: [],
    selectedSeats: [],
    selectedDoors: [],
    selectedAnnualCosts: [],
    selectedFeatures: [],
    resultsUpdated: false,
  }),
  actions: carAdvisoryActions,
  getters: carAdvisoryGetters,
  persist: true,
});
